import $ from 'jquery';
import Cookies from 'js-cookie';

/**
 * Integration of "klaro" (https://github.com/kiprotect/klaro)
 *
 * A rough typescript module declaration can be found in utils/klaro.d.ts
 * SCSS can be found in styles/components/_consent-management.scss
 */

// @see https://github.com/kiprotect/klaro/blob/master/dist/config.js
const klaroConfig = {
    acceptAll: true,
    groupByPurpose: false,
    hideDeclineAll: true,
    storageMethod: 'cookie',
    htmlTexts: true,
    lang: 'de',
    translations: {
        // @see https://github.com/kiprotect/klaro/blob/master/src/translations/de.yml
        de: {
            ok: "Akzeptieren",
            basic: {
                title: "",
                description: "Wir verwenden Pretix für die Abwicklung von Ticket-Verkäufen."
            },
            privacy: {
                title: "",
                description: "Wir verwenden Cookies, um Ihre Datenschutzeinstellungen zu speichern."
            },
            google_analytics: {
                title: "",
                description: "Wir verwenden die Webanalysedienste Google Analytics und Google Tag Manager."
            },
            google_maps: {
                title: "",
                description: "Wir verwenden Google Maps, um Standorte auf einer Karte darzustellen."
            },
            video_youtube: {
                title: "",
                description: "Wir verwenden den Video-Player-Dienst Youtube, um Videos auf der Website anzuzeigen."
            },
            purposes: {
                analytics: "Statistik",
                default: ""
            },
            acceptAll: "Akzeptieren",
            consentModal: {
                title: `Datenschutz&shy;einstellungen`,
                description: `<p>Um Ihnen ein optimales Nutzungserlebnis zu bieten, setzen wir Cookies und ähnliche Technologien für verschiedene Zwecke ein, unter anderem zur Einbindung von Videos und Standortkarten sowie um die Leistungs- und Funktionsfähigkeit unserer Website zu unterstützen.</p><p>Sie möchten noch mehr erfahren? Lesen Sie unsere <a href='/datenschutz.html' title='Datenschutzerklärung'>Datenschutzerklärung</a>.`
            },
            consentNotice: {
                description: `
                    <h3>Datenschutz&shy;einstellungen</h3>
                    <p>Um Ihnen ein optimales Nutzungserlebnis zu bieten, setzen wir Cookies und ähnliche Technologien für verschiedene Zwecke ein, unter anderem zur Einbindung von Videos und Standortkarten sowie um die Leistungs- und Funktionsfähigkeit unserer Website zu unterstützen.</p><p>Sie möchten noch mehr erfahren? Lesen Sie unsere <a href='/datenschutz.html' title='Datenschutzerklärung'>Datenschutzerklärung</a>.</p>
                `,
                learnMore: 'Einstellungen anpassen'
            },
            privacyPolicy: {
                text: ""
            },
            poweredBy: "",
            acceptSelected: 'Einstellungen speichern'
        }
    },
    services: [
        {
            name: 'basic',
            title: 'Grundlegende Website-Funktionen',
            purposes: ['default'],
            required: true,
        },
        {
            name: 'privacy',
            title: 'Speichern Ihrer Datenschutzeinstellungen',
            purposes: ['default'],
            required: true
        },
        {
            name: "video_youtube",
            title: "Externe Videos",
            purposes: ["youtube"],
            default: false,
        },
        {
            name: "google_maps",
            title: "Kartendienst",
            purposes: ["maps"],
            default: false,
        },
        {
            name: "google_analytics",
            title: "Messung und Analytik",
            purposes: ["analytics"],
            default: false,
        }
    ],
};

export default function ConsentManagement() {
    const manager = klaro.getManager(klaroConfig);
    if (!manager || !manager.consents || Cookies.get('klaro') === undefined) {
        klaro.render(klaroConfig, {show: true, modal: false});
        $('body').addClass('no-scroll');
    }

    $(document).on('click', '.cm-btn', (event) => {
        $('body').addClass('hide-klaro').removeClass('no-scroll');
    });
}

